import { useAsyncEffect } from 'ahooks'

import type React from 'react'

import { sha256 } from '@/helpers/sha256'
import { handleIdentify } from '@/hooks/analyticsData/helpers/handleIdentify'
import { useTrackSessionStart } from '@/hooks/analyticsData/hooks/sessionStart'
import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'
import { useTrackSignInOrSignUp } from '@/contexts/AuthContext/hooks/trackSignInOrSignUp'

export interface IUserTrackProps {}

const UserTrack: React.FC<IUserTrackProps> = (props) => {
  const { userId, email, isSignIn, sessionLoading } = useSessionInfo()

  useAsyncEffect(async () => {
    if (userId && email && isSignIn && !sessionLoading) {
      const emailSha256 = await sha256(email.toLowerCase())
      handleIdentify({
        userId,
        emailSha256,
      })
    }
  }, [userId, email, isSignIn, sessionLoading])

  useTrackSignInOrSignUp({ enabled: true })
  useTrackSessionStart()

  return null
}

export default UserTrack
